import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NewsService } from '../../shared/services/news.service';
import { LanguageService } from '../../shared/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { MetadatasService } from '../../shared/services/metadatas.service';

declare var $:any
import {isBrowser} from '../../shared/thirdparty/isBrowser'
import { AppService } from 'src/app/shared/services/app.service';

@Component({
    selector: 'app-actualite',
    templateUrl: './actualite.component.html',
    styleUrls: ['./actualite.component.scss']
})


export class ActualiteComponent implements OnInit {

    public routeSub:any = null
    public postId = null
    public post = null
    public lastPosts = [];
    public sameCatNews = []

    public isRd = false
    public isInterview = false

    public headings = null
    public checkActive = null

    author = {
        name: 'Aurélie Tavernier',
        image: 'https://data.immfactory.com/our_team/member_30_1668796288174.jpg',
        job: {
            fr: "Responsable Marketing et Communication chez Immersive Factory.",
            en: "Marketing and Communications Manager at Immersive Factory."
        },
        description: {
            fr: "Elle s'est prise d'intérêt pour la sensibilisation à la santé et à la sécurité au travail, convaincue qu’une approche adaptée aux collaborateurs peut transformer la culture sécurité et renforcer la vigilance partagée. Son ambition : encourager toutes les entreprises, quelle que soit leur taille, à s’investir activement dans la prévention santé et sécurité pour le bien-être de leurs employés.",
            en:"She became interested in raising awareness of health and safety at work, convinced that an approach tailored to employees can transform the safety culture and reinforce shared vigilance. Her ambition: to encourage all companies, whatever their size, to invest actively in health and safety prevention for the well-being of their employees."
        },
    }

    constructor(
        public activatedRoute: ActivatedRoute,
        public language : LanguageService,
        public newsService: NewsService,
        public translate : TranslateService,
        private router: Router,
        private _sanitizer: DomSanitizer,
        public metadatas : MetadatasService,
        private app : AppService
    ) {
        this.routeSub = this.activatedRoute.params
        .subscribe((params: Params) => {
            this.postId = params['articleId'].split("-")[0];
            this.refreshPost();
        });
    }

    ngOnInit() {
        this.isRd = this.router.url.includes('/research-innovation/') || this.router.url.includes('/recherche-innovation/')
        this.isInterview = this.router.url.includes('/interviews/')
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }

    refreshPost(){
        // this.getLastArticles()
        this.newsService.getNews(this.postId)
        .then(res => {
            if(res && !res['draft']){
                this.post = res
                this.post['img'] = this.newsService.getNewsHeader(this.post['imageHeader'])
                if(this.post['ytId']){
                    this.post['ytLink'] = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+this.post['ytId']+'?rel=0&amp;showinfo=0')
                }

                this.metadatas.setMetaTag('title', this.post["title"])
                // this.metadatas.setMetaTag('keywords', this.post["title"])

                this.metadatas.setMetaTag('og:type', 'article')
                this.metadatas.setMetaTag('og:article:published_time', new Date(this.post['createdDate']).toISOString())
                this.metadatas.setMetaTag('og:article:section', this.post['tag']['title'])

                this.metadatas.setMetaTag('og:image:width', null)
                this.metadatas.setMetaTag('og:image:height', null)
                this.metadatas.setMetaTag('og:image:type', null)
                if(this.post['ytId']){
                    this.metadatas.setMetaTag('image', 'https://img.youtube.com/vi/'+this.post['ytId']+'/maxresdefault.jpg')
                }
                else{
                    this.metadatas.setMetaTag('image', this.post['img'])
                }
                if(this.post['html']){
                    this.newsService.getNewsHTML(this.post['html'])
                    .then(res =>{
                        if(res){
                            this.post['srcContent'] = res

                            const { updatedHtmlContent, headings } = this.processHtmlContent(res);
                            this.post['htmlContent'] = this._sanitizer.bypassSecurityTrustHtml(updatedHtmlContent);
                            this.headings = headings;

                            if (isBrowser()) {
                                $(window).scroll(() => {
                                    let firstHeading = headings[0];
                                    if (this.checkActive == firstHeading.id && this.isHeadingVisible(firstHeading.id)) {
                                        this.checkActive = null;
                                    } else {
                                        for (let i = headings.length - 1; i >= 0; i--) {
                                            const heading = headings[i];
                                            if (this.isActive(heading.id)) {
                                                this.checkActive = heading.id;
                                                break;
                                            }
                                        }
                                    }
                                });
                            }

                            if(!this.post["shortDesc"]){
                                this.post["shortDesc"] = res.replace(new RegExp("<.[^<>]*>", "gi" ),"")
                                this.post["shortDesc"] = this.post["shortDesc"].slice(0, 227)+((this?.post?.shortDesc?.length>227) ? '...' : '')
                            }
                            if(this.post['metaDesc']){
                                this.metadatas.setMetaTag('description', this.post["metaDesc"])
                            }
                            else{
                                this.metadatas.setMetaTag('description', this.post["shortDesc"])
                            }
                            this.tryToDisplayEmbeds()
                        }
                        else{
                            this.metadatas.setMetaTag('description', this.post["title"])
                        }
                    })
                }
                this.getRelatedsArticles()
            }
            else{
                this.router.navigate(this.language.navigateAccordingToLang(['/blog']))
            }
        })
    }

    tryToDisplayEmbeds(){
        if(isBrowser()){
            this.app.loadScript("//cdn.embedly.com/widgets/platform.js")
            .then(()=>{
                document.querySelectorAll( 'oembed[url]' ).forEach( element => {
                    const anchor = document.createElement( 'a' );
                    anchor.setAttribute( 'href', element.getAttribute( 'url' ) );
                    anchor.className = 'embedly-card';
                    anchor.setAttribute('data-card-width', '100%')
                    element.appendChild( anchor );
                } );
            })
        }

    }


    getLastArticles(){
        if(!this.router.url.includes('/research-innovation/') && !this.router.url.includes('/recherche-innovation/') && !this.router.url.includes('/interviews/')){
            this.newsService.getNewss(0, 6)
            .then(res => {
                if(res['results']){
                    this.lastPosts = res['results'].filter(e => e['id'] != this.postId).slice(0,5)
                }
                else{
                    this.lastPosts = []
                }
                for(let post of this.lastPosts){
                    post['link'] = '/blog/'+this.newsService.getPostLink(post)
                }
            });
        }
        else{
          if(this.router.url.includes('/research-innovation/') || this.router.url.includes('/recherche-innovation/')){
            this.newsService.getPostsByTag(11, 0,6)
            .then(res => {
                this.lastPosts = res['results'].filter(e => e['id'] != this.postId).slice(0,5)
                for(let post of this.lastPosts){
                    post['link'] = '/research-innovation/'+this.newsService.getPostLink(post)
                }
            });
          }
          else{
            this.newsService.getPostsByTag(8, 0,6)
            .then(res => {
                this.lastPosts = res['results'].filter(e => e['id'] != this.postId).slice(0,5)
                for(let post of this.lastPosts){
                    post['link'] = '/interviews/'+this.newsService.getPostLink(post)
                }
            });
          }
        }
    }

    getRelatedsArticles(){
        this.newsService.getPostsByTag(this.post['tagId'], 0,4)
        .then(res => {
            this.sameCatNews = res['results'].filter(e => e['id'] != this.postId).slice(0,3)
        });
    }

    share(network){
        if(isBrowser()){
            var url = encodeURIComponent(window.location.href.toString())
            var href = encodeURIComponent(window.location.href.toString())
            var title = this.post['title']
            var source = "Immersive Factory"

            if(network == "fb"){
                return "https://www.facebook.com/sharer.php?u="+url
            }
            if(network == "tw"){
                return "https://twitter.com/intent/tweet?text="+url
            }
            if(network == "li"){
                return "https://www.linkedin.com/shareArticle?mini=true&url="+url+"&source="+source+"&title="+title
            }

            if(network == "mail"){
                href = 'mailto:?body='+source+' - '+title+' : '+url
                window.location.href = href
            }

            if(network == "print"){
                let printContents, popupPrint;
                popupPrint = window.open('', '_blank', 'top=0,left=0,height=auto,width=auto');
                popupPrint.document.open();
                popupPrint.document.write(`
                    <html>
                    <head>
                    <title>Print tab</title>
                    <link href="https://fonts.googleapis.com/css?family=Hind+Madurai:300,400,600" rel="stylesheet">
                    <style>
                    body{
                        font: 15px/22px 'Hind Madurai', sans-serif;
                        font-weight: normal;
                        font-weight: 300;
                    }

                    .printContent{
                        margin: auto;
                        max-width: 793.7013px;
                        text-align:center;
                        -webkit-box-shadow:inset 0 0 0 100000px rgba(255,255,255,0.93);
                        box-shadow:inset 0 0 0 100000px rgba(255,255,255,0.93);
                    }

                    img{
                        max-height:440px;
                        max-width: 100%;
                    }

                    h1{
                        color: #000000;
                        font-size: 36px;
                        line-height: 40px;
                        margin-bottom: 50px;
                        text-align: center;
                        font-weight: bold;
                        margin-top : 40px;
                    }
                    .date{
                        font-size: 14px;color: #565656;margin-top: 0;margin-bottom: 30px;text-transform: capitalize;margin-top: 5px;text-align:left;
                    }
                    .content{
                        text-align: justify;
                    }
                    .from{
                        margin-top : 50px;
                    }
                    </style>
                    </head>
                    <body>
                    <div class="printContent">
                    <h1>`+title+`</h1>
                    <img width="100%" src="`+this.post['img']+`" alt="imgHeader">
                    <p class="date">`+this.translate.instant('Posté le')+' '+this.language.getDate(this.post['createdDate'])+`</p>
                    <div class="content">`+this.post['srcContent']+`</div>
                    <div class="from"><img height="50px" src="https://immersivefactory.com/assets/logo_flat_textenoir.png" alt=""></div>
                    </div>
                    <script type="text/javascript">window.onload = function() { window.print(); }</script>
                    </body>
                    </html>
                `);
                popupPrint.document.close();
                popupPrint.focus();
                popupPrint.onafterprint = ()=>{ popupPrint.close(); };
                popupPrint.print();

            }
        }
    }


    // Met à jour le contenu de l'article en ajoutant un ID à chaque h2 et h3. Récupère aussi le texte, le level et l'id des h2 et h3
    processHtmlContent(htmlContent: string): { updatedHtmlContent: string, headings: { level: number, text: string, id: string }[] } {
      if (isBrowser()) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const headingElements = doc.querySelectorAll('h2, h3');
        const headings: { level: number, text: string, id: string }[] = [];
        const usedIds = new Set<string>(); // Ensemble pour stocker tous les IDs en s'assurant qu'ils sont bien uniques
        headingElements.forEach((headingElement, index) => {
            let text = headingElement.textContent.trim();
            const originalText = text;
            const id = this.generateUniqueId(text, index + 1, usedIds);
            headingElement.id = id;
            usedIds.add(id);
            headings.push({ level: parseInt(headingElement.tagName.charAt(1), 10), text: originalText, id });
        });

        const links = doc.querySelectorAll('a');
        links.forEach((linkElement, index) => {
            if(!linkElement.getAttribute('href')?.startsWith('https://immersivefactory') && !linkElement.getAttribute('href')?.startsWith('https://echangeformation')){
                const oldRel:string = linkElement.getAttribute('rel') ? linkElement.getAttribute('rel') as string : ''
                const rels = [...oldRel.split(' '), 'nofollow', 'noopener' ].filter(e => e != '')
                linkElement.setAttribute('rel', [...new Set(rels)].join(' '))
            }

        })

        return { updatedHtmlContent: doc.documentElement.innerHTML, headings };
      }
    }

    // Génère un ID unique
    generateUniqueId(text: string, index: number, usedIds: Set<string>): string {
      if (isBrowser()) {
        const sanitizedText = text.replace(/[^\w\s-]/g, '').trim();
        const words = sanitizedText.split(/\s+/);
        const truncatedText = words.slice(0, 6).join(' ');
        const id = truncatedText.toLowerCase().replace(/\s+/g, '-');
        if (usedIds.has(id)) {
            return `${id}-${index}`;
        }
        return id;
      }
    }

    // Système d'ancres
    goTo(id){
        if(isBrowser()) $('html, body').animate({
          scrollTop:$('#'+id).offset().top-70
        }, 'slow');
    }

    // On check si la position du heading est proche du haut de la page de navigation
    isActive(id: string): boolean {
        if (isBrowser()) {
            const $element = $('#' + id);
            if ($element.length !== 0) {
                const scrollTop = $(window).scrollTop();
                const elementTop = $element.offset().top;
                const threshold = 100;
                const isElementNearTop = (elementTop - scrollTop < threshold);
                return isElementNearTop;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // On check si on a scrollé au-dessus de la position du heading
    isHeadingVisible(id): boolean {
        if (isBrowser()) {
            const $element = $('#' + id);
            if ($element.length !== 0) {
                const scrollTop = $(window).scrollTop();
                const elementTop = $element.offset().top;
                const threshold = 100;
                const isElementVisible = elementTop - scrollTop > threshold;
                return isElementVisible;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

}
